(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .factory('optionalFeaturesActions', optionalFeaturesActionsFactory);

  /** @ngInject */
  function optionalFeaturesActionsFactory(api, $q, sessionData, jwtHelper) {
    var cachedFeatures = null;
    var cachePromise = null;

    return {
      getOptionalFeatures: getOptionalFeatures,
      hasFeature: hasFeature,
      clearCache: clearCache
    };

    function isCompanyUser() {
      var token = sessionData.getValue(sessionData.Keys.ACCESS_TOKEN_KEY);
      var claims = token ? jwtHelper.decodeToken(token) : {};
      return 'isCompanyLevel' in claims ? !!claims.isCompanyLevel : true;
    }

    function getOptionalFeatures(companyId) {
      if (!isCompanyUser()) {
        return $q.resolve([]);
      }

      if (cachedFeatures !== null) {
        return $q.resolve(cachedFeatures);
      }

      if (cachePromise !== null) {
        return cachePromise;
      }

      var deferred = $q.defer();
      cachePromise = deferred.promise;

      api.getMyCompanyOptionalFeatures(companyId).then(
        function (data) {
          cachedFeatures = data || [];
          cachePromise = null;
          deferred.resolve(cachedFeatures);
        },
        function (error) {
          cachePromise = null;
          deferred.reject(error);
        }
      );

      return deferred.promise;
    }

    function hasFeature(featureCode, companyId) {
      var deferred = $q.defer();

      getOptionalFeatures(companyId).then(
        function (features) {
          var hasIt = features.indexOf(featureCode) !== -1;
          deferred.resolve(hasIt);
        },
        function () {
          deferred.resolve(false);
        }
      );

      return deferred.promise;
    }

    function clearCache() {
      cachedFeatures = null;
      cachePromise = null;
    }
  }
})();
